import * as S from './styles';

export default function Blog() {
  return (
    <S.StyledBlog>
      <S.BlogTitle>KAMBU CAPSULE <br></br> Learn about the Kambu Capsule
      </S.BlogTitle>
      <S.ArticleMain>
        <S.ContainerImageMain>
          <a href="https://client-steel-mu.vercel.app/"><img src="images/products/blog-big.png" alt="mulher com roupa estilosa segurando uma bolsa" /></a>
        </S.ContainerImageMain>
        <S.Description>The Kambu Capsule is a wardrobe solution consisting of 6 core
fashion items that you can mix and match to create 12 different
looks.</S.Description>
      </S.ArticleMain>
      <S.Article position='top'>
        <S.ContainerImage>
          <a href="https://client-steel-mu.vercel.app/"><img src="images/products/blog-small-top.png" alt="mulher com roupa estilosa de cor lilás"></img></a>
        </S.ContainerImage>
        <S.Description>

The Kambu Collection draws inspiration from the elegant Kambu bird, known for its graceful presence in African folklore. Like this bird's diverse plumage, our collection offers versatile key pieces that empower you to express your unique style confidently. 
</S.Description>
      </S.Article>
      <S.Article position='bottom'>
        <S.ContainerImage>
          <a href="https://client-steel-mu.vercel.app/"><img src="images/products/blog-small-bottom.png" alt="mulher com roupa de cores claras usando óculos escuro"></img></a>
        </S.ContainerImage>
        <S.Description>Kambu Capsule Collection is for women and men who want to
feel confident, get inspired when they look into their closet, and
get intentional about what they wear.</S.Description>
      </S.Article>
    </S.StyledBlog>
  );
}